<template>
  <section
    class="bt card-style"
    id="entity-users-list"
    v-loading="loading"
    :element-loading-text="loadingText"
  >
    <entity-board-view
      :showFields="showFieldsParent"
      :take_value_from="showFieldsParent.take_value_from"
      :isApplicationUserSide="isApplicationUserSide"
      :currentMenu="currentMenu"
      :applyFiltersData="entityFiltersData"
      :getSelfEntityFilters="getSelfEntityFilters"
      :appliedQuickFilters="applied_quick_filters"
      :entityFiltersData="entityFiltersData"
      :entityUserFiltersData="entityUserFiltersData"
      :customization="customization"
      :currentEntity="currentEntity"
      @open-attachments="openAttachments"
      @open-SendNotification="openSendNotification"
      @open-WASendNotification="openWASendNotification(data)"
      @open-ScheduleEventModal="openScheduleEventModal(data)"
      @SaveData="checkForFilterUpdate"
    ></entity-board-view>

    <ActionButtonExecute
      v-if="quickActionModal && quickActionDummyField"
      :data="quickActionDummyField"
      :isView="false"
      :entityId="currentEntity._id"
      :entityDataId="quickActionDummyField.parent_entityDataId"
      :fromQuickAction="true"
      :entityData="rowEntityData"
      :selfTemplateId="quickActionDummyField.template_id"
      :allEntitiesData="allEntitiesData"
      :allEntityFields="allEntityFields"
      :form="quickActionDummyForm"
      @closeModal="quickActionModal = false"
    ></ActionButtonExecute>
  </section>
</template>

<script>
  import 'leaflet/dist/leaflet.css';
  import { mapGetters } from 'vuex';
  import NavigationHelper from '@/mixins/navigationHelper';
  import entityRelationshipMixin from '@/mixins/entityRelationshipMixin';
  import CustomDashboardConfig from '@/mixins/CustomDashboardHelper.js';
  import TemplateBuilderhelper from '@/mixins/templateBuilderHelper.js';
  import LayoutDataMixin from '@/mixins/DataFetchingHelper.js';
  import * as XLSX from 'xlsx';
  import AutomationHelper from '@/mixins/AutomationHelper';
  import { addSingleFilterToLocal, updateFilterData, deleteFilter } from '@/repo/filtersRepo';
  import FieldStylesHelper from '../../mixins/FieldStylesHelper';
  import fieldsFormatHelper from '../../mixins/FieldsFormatHelper';
  import { postAPICall } from '../../helpers/httpHelper';
  import { getAllFieldsArrayFromEntity } from '../../utils/formatter';
  export default {
    name: 'EntityBoardDataList',
    components: {
      EntityBoardView: () => import('@/components/widgets/entityViewWidgets/EntityBoardView'),
      ActionButtonExecute: () =>
        import('@/components/templates/formComponentsExecute/ActionButtonExecute'),
    },
    mixins: [
      NavigationHelper,
      LayoutDataMixin,
      entityRelationshipMixin,
      CustomDashboardConfig,
      TemplateBuilderhelper,
      AutomationHelper,
      FieldStylesHelper,
      fieldsFormatHelper,
    ],
    data() {
      return {
        bulkUploadDocsVisible: false,
        getEntityRecordsForTable: null,
        count: 0,
        entitybulkDeleteVisible: false,
        is_excelUploaded: false,
        mappedFileName: '',
        mapped_fields: [],
        unmapped_fields: [],
        matchDialogVisible: false,
        is_active: 0,
        uploadedfileDataNames: [],
        existedField: '',
        uploadedFileObject: {},
        selectedRowsIds: [],
        loading: false,
        loadingText: 'Loading...',
        entityDataId: null,
        dialogTableVisible: false,
        selectedNotifyEntity: null,
        sendNotificationDialog: false,
        sendWANotificationDialog: false,
        quickActionDummyField: null,
        quickActionModal: false,
        quickActionDummyForm: {},
        openAttachmentsModal: false,
        selectedAttachmentData: null,
        rowEntityData: {},
        showQrReader: false,
        openExportCSVDialogModal: false,
        selectedTableExcelType: 'ADD_INNER_TABLE',
      };
    },
    computed: {
      ...mapGetters('entities', [
        'getEntityPrimaryData',
        'getmappedFieldsData',
        'getuploadedFilesData',
        'getentitydataBulkDeleteStatus',
        'getEntitydataBulkDeleteErrors',
        'getEntityShowFields',
        'getEntityDataExportPDFStatus',
      ]),
      ...mapGetters('filters', [
        'getCreateNewFilter',
        'getUpdateFilterStatus',
        'getUpdateFilterData',
        'getDeleteFilterStatus',
        'getCreateNewFilterError',
        'getUpdateFilterError',
        'getDeleteFilterErros',
      ]),
      ...mapGetters('auth', ['getAuthenticatedUser']),
      ...mapGetters('menuManagementV2', ['getEntityMenu']),
      ...mapGetters('iFrame', ['getIframeUrlInfo']),
      currentMenu() {
        if (
          this.isApplicationUserSide &&
          this.$route?.params?.menuId &&
          this.getEntityMenu?.menu_list
        ) {
          let menu;
          let id = this.$route.params.menuId || this.$route.query.menu_id;
          this.getEntityMenu.menu_list.forEach((e) => {
            if (e._id == id) {
              menu = e;
            } else if (e.children) {
              (e.children || []).forEach((el) => {
                if (el._id == id) {
                  menu = el;
                } else if (el.children) {
                  (el.children || []).forEach((ele) => {
                    if (ele._id == id) {
                      menu = ele;
                    }
                  });
                }
              });
            }
          });
          return menu;
        }
        return null;
      },
      getSelfEntityFilters() {
        if (this.isApplicationUserSide && this.getAuthenticatedUser?.contact_types) {
          let currentActiveWorkspace = this.getAuthenticatedUser.contact_types.find((e) => {
            let id = e.contact_type && e.contact_type._id ? e.contact_type._id : e.contact_type;
            if (id && id == this.activeWorkspace) {
              return true;
            }
          });
          let value =
              currentActiveWorkspace && currentActiveWorkspace.account_data_id
                ? currentActiveWorkspace.account_data_id
                : '',
            relationalEntityId = this.activeWorkspace;
          if (this.currentMenu?.self_related_filter != 'login_user' && this.getEntityPrimaryData) {
            let [entityId, templateId, fieldKey] = this.currentMenu.self_related_filter?.split('#');
            let tempData = this.getEntityPrimaryData.templates_data.find(
              (tempData) => tempData.template_id == templateId
            );
            if (tempData?.template_data_id?.template_data?.[fieldKey]) {
              value = tempData.template_data_id.template_data[fieldKey];
            } else {
              value = '';
            }
            relationalEntityId = entityId;
          }
          return [
            {
              field: 'self#related_to/1',
              operator: '=',
              value: value,
              value_type: '',
              value_source: '',
              query_type: 'OR',
              value_field: '',
              validations: {
                data_type: '',
              },
              nested_related_id: '',
              data_source: 'self_field',
              relation_entity_id: relationalEntityId,
              data_type: 'RELATION',
            },
          ];
        }
        return [];
      },
      getCurrentFilter() {
        return this.entityAllFilters.find((e) => e && e._id == this.currentFilter);
      },
      getMainLabel() {
        if (this.entityFiltersData && this.entityFiltersData.tableFieldGroupBy) {
          return this.getLabel(this.entityFiltersData.tableFieldGroupBy);
        }
        return '';
      },
    },
    async mounted() {
      require('../../assets/css/view-data.scss');
      this.menuTitleLoading = true;
      this.getRequiredKeyValues();
      this.getNecessaryInfo();

      await this.isIframe();
      this.checkRoutekey = this.generateOutputFromUrl(this.$route.fullPath, [
        'key',
        'page',
        'pageSize',
      ]);
      this.$nextTick(() => {
        this.getEntitiesAndTemplates();
      });
    },
    async created() {
      await this.initializeWorkersAndSockets();
    },
    methods: {
      actionType(data) {
        switch (data) {
          case 'BACK_ACTION':
            this.backToEntities();
            return;
          case 'IMPORT_EXCEL':
            this.displayimportdialog();
            return;
          case 'IMPORT_ZIP':
            this.zipImportDialog();
            return;
          case 'IMPORT_DOCS':
            this.bulkUploadDocsVisible = true;
            return;
          case 'EXPORT_EXCEL':
            this.openExportCSVDialog();
            return;
          case 'EXPORT_PDF':
            this.exportPDF();
            return;
          case 'SETTINGS':
            this.openSettingsModal();
            return;
          case 'QR':
            this.showQrReader = true;
            return;
          case 'FILTERS':
            this.openCompanyFilterModel();
            return;
          case 'FILTERS_IFRAME':
            this.openFilterModel();
            return;
          case 'QUICK_FILTERS_OPEN':
            return { title: 'About Page', content: 'Learn more about us here.' };
          case 'QUICK_FILTERS_CLOSE':
            return { title: 'Contact Page', content: 'Get in touch with us!' };
          case 'IFRAME':
            this.ViewConfigPage();
            return;
          case 'LAYOUT':
            this.entityViewModal = true;
            return;
          default:
            return;
        }
      },
      async getNecessaryInfo() {
        await this.getRequiredData();
      },
      openExportCSVDialog() {
        let isTablePresent = this.allEntityFields.some(
          (field) => field.input_type === 'ENTITY_TABLE' || field.input_type === 'DATA_TABLE'
        );
        if (isTablePresent) {
          this.openExportCSVDialogModal = true;
        } else {
          this.exportCSV();
        }
      },
      removeKeyListener() {
        document.removeEventListener('keydown', this.handleKeyDown);
      },
      handleKeyDown(event) {
        if (event.key === 'Enter') {
          this.deleteCheckedEntityData();
        }
      },
      openAttachments(row) {
        this.selectedAttachmentData = row;
        this.openAttachmentsModal = true;
      },
      async openSendNotification(entityData) {
        this.selectedNotifyEntity = entityData;
        this.sendNotificationDialog = true;
        this.sendWANotificationDialog = false;
      },
      async openWASendNotification(entityData) {
        this.selectedNotifyEntity = entityData;
        this.sendNotificationDialog = false;
        this.sendWANotificationDialog = true;
      },
      async openScheduleEventModal(entityData) {
        let currentEntityData = entityData;
        let currentEntity = this.currentEntity;
        this.$eventBus.$emit('showCalendarEvent', {
          source: 'entity',
          entityId: currentEntity._id,
          entityDataId: currentEntityData._id,
        });
      },
      async checkForFilterUpdate() {
        this.entityViewModal = false;
        this.filterColumList = this.filterColumList.filter((e) => e.id && e.template_id);
        if (this.isApplicationUserSide) {
          let data = this.getEntityShowFields || {};
          if (data) {
            data[this.currentEntity._id] = { ...this.showFieldsParent };
          }
          await this.$store.commit('entities/setEntityShowFields', data, {
            root: true,
          });
        } else if (this.currentFilter) {
          await this.$store.dispatch('filters/updateFilter', {
            id: this.currentFilter,
            params: {
              columns_settings: this.filterColumList,
              email_template_id: this.getSelectedEmailTemplate(),
            },
          });
        } else {
          await this.$store.dispatch('entities/updateEntityById', {
            settings: this.filterColumList,
            name: this.currentEntity.name,
            description: this.currentEntity.description,
            entity_type: this.currentEntity.entity_type,
            templates: this.currentEntity.templates,
            id: this.currentEntity._id,
            primaryFields: this.currentEntity.primaryFields,
            views_configuration: this.showFieldsParent,
            viewType: this.activeLayout,
          });
        }
      },
      async activeLayout(layout) {
        if (this.activeEntityView !== layout) {
          try {
            this.activeEntityView = layout;

            let query = await this.getNavigationQuery(this.$route.query);
            query['viewType'] = layout;

            await this.$router.push({
              name: this.$route.name,
              query: query,
            });
            let entity = this.currentEntity;
            let params = {
              id: entity._id,
              name: entity.name,
              description: entity.description,
              entity_type: entity.entity_type,
              templates: entity.templates,
              primaryFields: entity.primaryFields,
              settings: entity.settings,
              viewType: layout,
            };
            if (layout == 'HTML_CONTENT' && this.getSelectedEmailTemplate()) {
              params['selected_email_template'] = this.getSelectedEmailTemplate();
              params['columns_per_row'] = this.showFieldsParent.columnsPerRow;
              params['emailView'] = this.showFieldsParent.emailView;
            }
            await this.$store.dispatch('entities/updateEntityById', params);
            if (layout == 'HTML_CONTENT') this.fetchEntitiesDataForTable([]);
          } catch (error) {
            console.error('Error updating layout:', error);
          }
        }
      },
      downloadExcelFromJson(csvData, fileName) {
        const worksheet = XLSX.utils.json_to_sheet(csvData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);

        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 0);
      },
      clearImportData() {
        this.mapped_fields = [];
        this.unmapped_fields = [];
        this.getmappedFieldsData = [];
        this.uploadedFileObject = null;
        this.is_excelUploaded = false;
        this.is_active = 0;
        this.mappedFileName = '';
        this.existedField = '';
        this.matchDialogVisible = true;
      },
      async displayimportdialog() {
        let params = {
          id: this.entity_id,
        };
        this.loading = true;
        await this.$store.dispatch('entities/getuploadedFiles', params);
        if (this.getuploadedFilesData && this.getuploadedFilesData.data) {
          this.uploadedfileDataNames = this.getuploadedFilesData.data;
        }
        this.clearImportData();
        this.loading = false;
      },
      async downloadGroupbyData() {
        let filters = this.applied_filters;
        if (this.currentMenu?.entity_type == 'RELATIONAL_ENTITY' && this.isApplicationUserSide) {
          filters = [...filters, ...this.getSelfEntityFilters];
        }
        if (!this.entityFiltersData && this.$route.query.filter) {
          this.resetEntityFiltersData();
        }
        filters = [...this.entityFiltersData.filters, ...filters];
        this.exportFilters = filters;
        let checkDataTable = this.filterColumList.find((e) => e.type == 'DATA_TABLE');
        let params = {
          entity_id: this.entity_id,
          template_fields_data: getAllFieldsArrayFromEntity(this.currentEntity),
          format_data: true,
          filters: this.mapDateFilters(
            this.addGlobalFilters(filters || [], this.entity_id, this.checkGlobalFilter)
          ),
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          search_string: this.search_string,
          data_table_field: checkDataTable,
        };
        if (this.entityFiltersData?.tableFieldGroupBy) {
          let subField = this.getField(this.entityFiltersData.tableFieldGroupBy);
          if (subField?.inputType == 'MULTI_SELECT') {
            params.unwind = true;
          }
          params.group_by = this.entityFiltersData.tableFieldGroupBy;
          params.group_by_fields = this.entityFiltersData.tableFieldGroupByFields;
          if (this.entityFiltersData?.tableFieldSubGroupBy) {
            params.sub_group_by = this.entityFiltersData?.tableFieldSubGroupBy;
          } else {
            params.entity_variable_columns = this.entityFiltersData.filterEntityVariableColumns;
            if (this.getField(this.entityFiltersData.tableFieldGroupBy)?.entity_id) {
              params.filter_variable_entity = this.getField(
                this.entityFiltersData.tableFieldGroupBy
              ).entity_id;
            }
          }
        }
        const v2Response = await postAPICall('POST', '/entities-data/entity/data/v2', params);
        this.getEntityRecordsForTable = v2Response?.data;
        let groupedData = [],
          csvData = [];
        if (this.entityFiltersData?.tableFieldGroupBy) {
          if (this.entityFiltersData?.tableFieldSubGroupBy) {
            let custom_columns = [];
            groupedData = this.getEntityRecordsForTable.data.map((data) => {
              if (data?.properties) {
                let label = '',
                  total = 0;
                (data.properties || []).forEach((el) => {
                  if (!label) {
                    label = el.entity_label;
                  }
                  total = total + el.count;
                  let value = el.sub_entity_label ? el.sub_entity_label : el.label;
                  let index = custom_columns.findIndex((e) => e.value == el.label);
                  if (index == -1 && value) {
                    custom_columns.push({
                      value: el.label,
                      label: value,
                    });
                  }
                  (Object.keys(el) || []).forEach((key) => {
                    if (['entity_label', 'label', 'sub_entity_label'].indexOf(key) == -1) {
                      data[el.label + '?' + key] = el[key];
                      data[value + '?' + key] = el[key];
                    }
                  });
                });

                data.entity_label = label;
                data.count = total;
              }
              return data;
            });
            if (
              this.entityFiltersData?.table_field_group_by_selected_options &&
              this.entityFiltersData.table_field_group_by_selected_options.length
            ) {
              custom_columns = custom_columns.filter(
                (e) =>
                  this.entityFiltersData.table_field_group_by_selected_options.indexOf(e.value) !=
                  -1
              );
            }
            this.entityFiltersData.tableFieldGroupByFields
              .filter((e) => e.sub_group)
              .forEach((field) => {
                (custom_columns || []).forEach((col) => {
                  this.custom_columns.push({
                    label: col.label + '-' + field.name,
                    value: col.value + '?' + field.key,
                  });
                });
              });
          } else {
            groupedData = this.getEntityRecordsForTable.data;
            groupedData = this.groupedData.map((e) => {
              if (e && e.name && e.name.includes('#')) {
                e.name = e.name.split('#')[0];
              }
              return e;
            });
          }
        }
        groupedData.forEach((data) => {
          let obj = {};
          obj[this.getMainLabel] = data.entity_label ? data.entity_label : data._id;
          this.entityFiltersData.tableFieldGroupByFields
            .filter((e) => !e.sub_group)
            .forEach((step) => {
              obj[step.name] = data[step.key];
            });
          this.custom_columns.forEach((step) => {
            obj[step.label] = this.getSubField(data, step.value);
          });
          csvData.push(obj);
        });
        this.downloadExcelFromJson(csvData, 'ExcelData');
      },
      async exportCSV() {
        this.openExportCSVDialogModal = false;
        if (this.entityFiltersData.tableFieldGroupBy) {
          await this.downloadGroupbyData();
          return;
        }
        let params = {
          id: this.entity_id,
          entityName: this.currentEntity.name,
          filters: this.mapDateFilters(this.exportFilters || []),
          dataIds: this.exportDataIds,
          selectedFilter: this.currentFilter,
          selectedExcelTypeForTables: this.selectedTableExcelType,
        };
        this.loadingText = 'Generating Excel...';
        this.loading = true;
        await this.$store.dispatch('entities/entityDataExport', params);
        this.loading = false;
        this.loadingText = 'Loading...';
      },
      async exportPDF() {
        let params = {
          id: this.entity_id,
          entityName: this.currentEntity.name,
          filters: this.mapDateFilters(this.exportFilters || []),
          selectedFilter: this.currentFilter,
          dataIds: this.exportDataIds,
          document_id: this.currentEntity?.export_printing_document,
        };
        this.loading = true;
        this.loadingText = 'Generating PDF...';
        await this.$store.dispatch('entities/entityDataExportPDF', params);
        if (
          this.getEntityDataExportPDFStatus &&
          this.getEntityDataExportPDFStatus.success &&
          this.getEntityDataExportPDFStatus.data.length
        ) {
          await this.downloadEntityDataPdf(
            this.getEntityDataExportPDFStatus.data[0],
            this.currentEntity?.name
          );
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Error while generating Document',
          });
        }
        this.loading = false;
        this.loadingText = 'Loading...';
      },
      async deleteCheckedEntityData() {
        let selectedIds = [];
        this.selectedRowsIds.forEach((item) => {
          if (item && item._id) {
            selectedIds.push(item._id);
          }
        });
        this.count = selectedIds.length;
        let params = {
          selectedIds: selectedIds,
          entity_id: this.entity_id,
        };
        this.entitybulkDeleteVisible = false;
        this.loading = true;
        await this.$store.dispatch('entities/entitydataBulkDelete', params);
        if (this.getentitydataBulkDeleteStatus && this.getentitydataBulkDeleteStatus.message) {
          this.fetchEntitiesDataForTable();
          this.selectedRowsIds = [];
          this.$notify.success({
            title: 'Success',
            message: this.getentitydataBulkDeleteStatus.message,
          });
          this.loading = false;
        } else {
          let message = 'Error in deleting data';
          if (this.getEntitydataBulkDeleteErrors) {
            message = this.getEntitydataBulkDeleteErrors;
          }
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message: message,
          });
        }
      },
      async openSettingsModal() {
        if (
          this.entityFiltersData &&
          this.entityFiltersData.columns_settings &&
          this.entityFiltersData.columns_settings.length
        ) {
          this.refresh = true;
          this.selectedTableFields = [];
          let allKeys = this.fieldsListData
            .flatMap((temp) => temp.children)
            .map((fd) => fd.template_id + '#' + fd.id);
          this.entityFiltersData.columns_settings = this.entityFiltersData.columns_settings.filter(
            (fd) => allKeys.includes(fd.template_id + '#' + fd.id)
          );
          this.selectedTableFields = this.getValidColumnSettings(
            this.entityFiltersData.columns_settings
          ).map((e) => e.id);
          this.treeCheckedNodes = this.getValidColumnSettings(
            this.entityFiltersData.columns_settings
          );
          setTimeout(() => {
            this.refresh = false;
          });
        }
        if (this.currentFilter && this.getCurrentFilter) {
          this.filterColumns = [];
          if (this.getCurrentFilter.tableFieldGroupByFields) {
            this.getCurrentFilter.tableFieldGroupByFields.forEach((e) => {
              if (e?.sub_group) {
                this.filterColumns.push('sub_group/' + e.key);
              } else {
                this.filterColumns.push(e.key);
              }
            });
          } else {
            this.filterColumns.push('count');
          }
          if (this.getCurrentFilter?.tableFieldGroupBy) {
            let subField = this.getField(this.getCurrentFilter.tableFieldGroupBy);
            if (this.getCurrentFilter?.filterEntityVariableColumns) {
              this.filterVariableColumns = this.getCurrentFilter.filterEntityVariableColumns;
            }
            if (subField?.input_type == 'ENTITY') {
              this.loading = true;
              this.allOtherEntityFields = await this.fetchEntityDetails(subField.entity_id, true);
              this.allOtherEntityFields = this.allOtherEntityFields.filter((e) => e.key);
              this.loading = false;
            }
          }
        }
        this.dialogTableVisible = true;
      },
      getSubField(data, step) {
        let value = 0,
          key = step && step.includes('?') ? step.split('?')[1] : step;
        let field = this.getField(key);
        if (data && step && data[step]) {
          value = data[step];
        }
        if (field?.inputType == 'CURRENCY') {
          let type = field.validations.currency ? field.validations.currency : 'USD';
          let locale = field.validations.locale ? field.validations.locale : 'en-US';
          value = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: type,
          }).format(value);
        } else if (field?.inputType == 'AGGREGATE_FUNCTION') {
          let isCurrencyField = (field.selected_fields || []).find((el) => {
            if (el?.inputType == 'CURRENCY' || el?.result_type == 'CURRENCY') {
              return true;
            }
          });
          if (isCurrencyField) {
            let type =
              isCurrencyField && isCurrencyField.validations && isCurrencyField.validations.currency
                ? isCurrencyField.validations.currency
                : 'USD';
            let locale =
              isCurrencyField && isCurrencyField.validations && isCurrencyField.validations.locale
                ? isCurrencyField.validations.locale
                : 'en-US';
            value = new Intl.NumberFormat(locale, {
              style: 'currency',
              currency: type,
            }).format(value);
          } else {
            return value;
          }
        }
        return value;
      },
      async deleteFilter() {
        let id = this.entityFiltersData._id ? this.entityFiltersData._id : '';
        if (!id) {
          this.$notify({
            title: 'Error',
            message: 'Filter not selected',
            type: 'error',
          });
          return;
        }
        this.loading = true;
        await this.$store.dispatch('filters/deleteFilter', id);
        if (this.getDeleteFilterStatus) {
          await deleteFilter(id);
          this.dialogEdit = false;
          this.resetEntityFiltersData();
          if (this.$route.query.routeType) {
            this.UsercurrentFilter = '';
          }
          this.currentFilter = '';
          this.loading = false;
          this.$notify({
            title: 'Success',
            message: 'Filters deleted',
            type: 'success',
          });
          this.loading = false;
          this.fetchAllEntityFilters();
          this.fetchEntitiesDataForTable();
        } else {
          this.loading = false;
          let msg = 'Failed to delete the filters';
          if (this.getDeleteFilterErros?.message) {
            msg = this.getDeleteFilterErros.message;
          }
          this.$notify({
            title: 'Error',
            message: msg,
            type: 'error',
          });
        }
      },
      async updateFilter() {
        let params = this.prepareFilterParams();
        if (!params.filter_name) {
          this.$notify({
            title: 'Error',
            message: 'Please enter Filter name',
            type: 'error',
          });
          return;
        }
        let id = this.entityFiltersData._id ? this.entityFiltersData._id : '';
        if (!id) {
          await this.saveFilter();
        }
        await this.$store.dispatch('filters/updateFilter', {
          id: id,
          params: params,
        });
        if (this.getUpdateFilterStatus) {
          if (this.getUpdateFilterData?.data) {
            await updateFilterData(id, this.getUpdateFilterData.data);
          }
          this.$notify({
            title: 'Success',
            message: 'Filters updated',
            type: 'success',
          });
          this.loading = true;
          await this.fetchAllEntityFilters();
          this.loading = false;
        } else {
          this.loading = false;
          let msg = 'Failed to Save the filters';
          if (this.getUpdateFilterError && this.getUpdateFilterError.message) {
            msg = this.getUpdateFilterError.message;
          }
          this.$notify({
            title: 'Error',
            message: msg,
            type: 'error',
          });
        }
      },
      prepareFilterParams() {
        return {
          filter_name: this.entityFiltersData.filter_name.trim(),
          filters: this.entityFiltersData.filters,
          sortBy: this.entityFiltersData.sortBy,
          sortOrder: this.entityFiltersData.sortOrder,
          entity_id: this.entity_id,
          quick_filters: this.entityFiltersData.quick_filters,
          permissions: this.entityFiltersData.permissions,
          tableFieldGroupBy: this.entityFiltersData.tableFieldGroupBy || '',
          tableFieldSubGroupBy: this.entityFiltersData.tableFieldSubGroupBy || '',
          tableFieldGroupByFields: this.entityFiltersData.tableFieldGroupByFields || [],
          filterEntityVariableColumns: this.entityFiltersData.filterEntityVariableColumns,
          displayType: this.entityFiltersData.displayType,
          data_limit: this.entityFiltersData.data_limit,
          email_template_id: this.getSelectedEmailTemplate(),
          ...(this.$route.query.routeType && {
            filter_name: this.entityUserFiltersData.filter_name.trim(),
            parent_filter_id: this.entityUserFiltersData.parentFilterId,
            role_id: this.getAuthenticatedUser.activeRole.role_id,
          }),
        };
      },
      async saveFilter() {
        let params = this.prepareFilterParams();
        if (!params.filter_name) {
          this.$notify({
            title: 'Error',
            message: 'Please enter Filter name',
            type: 'error',
          });
          return;
        }
        await this.$store.dispatch('filters/fetchCreateNewFilter', params);
        if (this.getCreateNewFilter) {
          this.showFieldsParent.selectedFilter = [this.getCreateNewFilter._id];
          if (this.$route.query.routeType) {
            this.UsercurrentFilter = this.getCreateNewFilter._id;
          }
          this.currentFilter = this.getCreateNewFilter._id;
          await addSingleFilterToLocal(this.getCreateNewFilter);
          this.$notify({
            title: 'Success',
            message: 'Filters saved',
            type: 'success',
          });
          this.loading = true;
          await this.fetchAllEntityFilters();
          this.loading = false;
        } else {
          this.loading = false;
          let msg = 'Filter name already exists';
          if (this.getCreateNewFilterError && this.getCreateNewFilterError.message) {
            msg = this.getCreateNewFilterError.message;
          }
          this.$notify({
            title: 'Error',
            message: msg,
            type: 'error',
          });
        }
      },
    },
    async beforeDestroy() {
      this.removeKeyListener();
      this.resetStore();
      await this.terminateWorkers();
    },
  };
</script>
